import { useState } from "react";
import { rankingNew, rankingWeek } from "@/mocks/home";

type Tab = "week" | "new";

function TrendIcon({ trend }: { trend: string }) {
  if (trend === "up") {
    return <i className="ri-arrow-up-line text-sm text-primary-500"></i>;
  }
  if (trend === "down") {
    return <i className="ri-arrow-down-line text-sm text-secondary-500"></i>;
  }
  return <i className="ri-subtract-line text-sm text-foreground-400"></i>;
}

export default function RankingBoard() {
  const [tab, setTab] = useState<Tab>("week");
  const data = tab === "week" ? rankingWeek : rankingNew;

  return (
    <div className="overflow-hidden rounded-lg border border-background-200/80 bg-background-50">
      {/* header */}
      <div className="border-b border-background-200/70 bg-background-100/60 px-5 py-4">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
              <i className="ri-bar-chart-2-fill text-base"></i>
            </span>
            <div>
              <h3 className="font-heading text-base font-black text-foreground-950">热度榜单</h3>
              <p className="text-[11px] text-foreground-500">基于全站阅读与追番数据</p>
            </div>
          </div>
        </div>

        {/* tab switcher */}
        <div className="mt-4 flex rounded-full bg-background-200/70 p-1">
          <button
            type="button"
            onClick={() => setTab("week")}
            className={
              tab === "week"
                ? "flex-1 cursor-pointer rounded-full bg-background-50 px-3 py-1.5 text-sm font-medium text-foreground-950"
                : "flex-1 cursor-pointer rounded-full px-3 py-1.5 text-sm font-medium text-foreground-600 transition-colors hover:text-foreground-900"
            }
          >
            本周热度
          </button>
          <button
            type="button"
            onClick={() => setTab("new")}
            className={
              tab === "new"
                ? "flex-1 cursor-pointer rounded-full bg-background-50 px-3 py-1.5 text-sm font-medium text-foreground-950"
                : "flex-1 cursor-pointer rounded-full px-3 py-1.5 text-sm font-medium text-foreground-600 transition-colors hover:text-foreground-900"
            }
          >
            新番期待
          </button>
        </div>
      </div>

      {/* list */}
      <ol className="divide-y divide-background-200/70">
        {data.map((item) => (
          <li
            key={item.title}
            className="group flex cursor-pointer items-center gap-3 px-5 py-3.5 transition-colors hover:bg-background-100/70"
          >
            <span
              className={
                item.rank <= 3
                  ? "w-6 shrink-0 text-center font-heading text-xl font-black text-primary-500"
                  : "w-6 shrink-0 text-center font-heading text-xl font-black text-foreground-300"
              }
            >
              {item.rank}
            </span>
            <div className="h-11 w-11 shrink-0 overflow-hidden rounded-md bg-background-100">
              <img
                src={item.image}
                alt={item.alt}
                title={`${item.title} · 热度榜单`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-1.5">
                <p className="truncate font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {item.title}
                </p>
                <TrendIcon trend={item.trend} />
              </div>
              <p className="mt-0.5 truncate text-xs text-foreground-500">{item.subtitle}</p>
              <div className="mt-1.5 flex items-center gap-2">
                <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                  <div
                    className="h-full rounded-full bg-primary-500"
                    style={{ width: `${item.heat}%` }}
                  ></div>
                </div>
                <span className="w-10 shrink-0 text-right text-xs font-medium text-foreground-700">
                  {item.heat}
                </span>
              </div>
            </div>
          </li>
        ))}
      </ol>

      <div className="border-t border-background-200/70 px-5 py-3">
        <a
          href="#ranking"
          className="group inline-flex cursor-pointer items-center gap-1.5 text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
        >
          查看完整榜单
          <i className="ri-arrow-right-s-line text-base transition-transform group-hover:translate-x-0.5"></i>
        </a>
      </div>
    </div>
  );
}